/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';
import {
  GET_PREFERRED_TIME_FORMAT,
  GET_PREFERRED_TIME_FORMAT_DONE,
  GET_PREFERRED_TIME_FORMAT_ERROR,
  SET_PREFERRED_TIME_FORMAT,
  SET_PREFERRED_TIME_FORMAT_DONE,
  SET_PREFERRED_TIME_FORMAT_ERROR,
  GetPreferredTimeFormatActionType,
  SetPreferredTimeFormatActionType
} from 'store/action';
import {TimeFormats} from 'utility';

export interface IPreferredTimeFormatState {
  isFetching: boolean;
  error: null | string;
  timeFormat: TimeFormats;
}

const defaultState = {
  isFetching: false,
  error: null,
  timeFormat: TimeFormats.Utc
};
const preferredTimeFormatReducer: Reducer<Readonly<IPreferredTimeFormatState>, GetPreferredTimeFormatActionType | SetPreferredTimeFormatActionType> = (
  state: IPreferredTimeFormatState = defaultState,
  action: GetPreferredTimeFormatActionType | SetPreferredTimeFormatActionType
) => {
  switch (action.type) {
    case GET_PREFERRED_TIME_FORMAT:
    case SET_PREFERRED_TIME_FORMAT: {
      return {
        ...state,
        isFetching: true,
        error: null
      };
    }

    case GET_PREFERRED_TIME_FORMAT_DONE:
    case SET_PREFERRED_TIME_FORMAT_DONE: {
      return {
        ...state,
        isFetching: false,
        error: null,
        timeFormat: action.payload.data
      };
    }

    case SET_PREFERRED_TIME_FORMAT_ERROR:
    case GET_PREFERRED_TIME_FORMAT_ERROR: {
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    }

    default:
      return state;
  }
};

export default preferredTimeFormatReducer;